import { IActivity } from '@sdk/contracts';
import { Flex, Switch } from 'antd';
import { useTranslation } from 'react-i18next';

import { useLocalCourse } from '@/store';

type Props = {
  sectionId: string;
  activity: IActivity;
};

export const ToogleActivityPlanificable: React.FC<Props> = ({ sectionId, activity }) => {
  const { t } = useTranslation('CourseTranslations');
  const { updateLocalActivity } = useLocalCourse();

  const title = activity.isPlanificable
    ? t('PLANIFICABLE_ACTIVITY')
    : t('NOT_PLANIFICABLE_ACTIVITY');

  const handleChange = (isPlanificable: boolean) =>
    updateLocalActivity(sectionId, {
      ...activity,
      isPlanificable
    });

  return (
    <Flex gap={24} align="center" justify="space-between">
      <span>{title}</span>
      <Switch size="small" checked={activity.isPlanificable} onChange={handleChange} />
    </Flex>
  );
};
